/** Claims de privilégio (fonte: `GET /api/usuarios/me/permissoes`). Formato: `hub.<modulo>:<acao>`; a lista fixada fica em `claims.fixture.ts`. */
export const HUB_PERMISSOES = {
  /** Visualização de equipe de obra. */
  EQUIPES_VISUALIZACAO: "hub.equipe:view",
  /** Cadastro/edição de equipe de obra (HU 2050/2051). */
  EQUIPES_CADASTRO: "hub.equipe:edit",
  /** Exportação (Excel/CSV/PDF) da listagem e do detalhe de embarcação (HU 2388). */
  EMBARCACOES_EXPORTACAO: "hub.embarcacao:export",
  /** Consulta de obras do Financeiro (HU 2670): aplicada pela API, que responde 403 sem ele. */
  FINANCEIRO_OBRAS_CONSULTA: "hub.financeiro:view-painel",
  /** Consulta de fichas financeiras da obra (HU 2679): oculta a ação sem o privilégio. */
  FINANCEIRO_FICHAS_CONSULTA: "hub.financeiro:view-fmm",
  /** Exportação e e-mail da ficha financeira (HU 2689): oculta as ações sem o privilégio. */
  FINANCEIRO_FICHAS_EXPORTACAO: "hub.financeiro:edit-fmm",
  /** Geração de ficha financeira da obra (HU 2684) e inclusão/remoção de anexos (HU 2688): oculta as ações sem o privilégio. */
  FINANCEIRO_FICHAS_GERACAO: "hub.financeiro:add-ficha",
  /** Edição do rótulo das claims no catálogo da aba Permissões. */
  PERMISSAO_EDICAO: "hub.permissao:edit",
  /** Visualizar auditoria. */
  AUDITORIA_VIEW: "hub.auditoria:view",
  /** Cadastrar embarcações. */
  EMBARCACAO_ADD: "hub.embarcacao:add",
  /** Aprovar cadastro de embarcações. */
  EMBARCACAO_APPROVE_CADASTRO: "hub.embarcacao:approve-cadastro",
  /** Atualizar financeiros padrão. */
  EMBARCACAO_EDIT_FINANCEIRO: "hub.embarcacao:edit-financeiro",
  /** Visualizar embarcações. */
  EMBARCACAO_VIEW: "hub.embarcacao:view",
  /** Cadastrar profissionais. */
  EQUIPE_ADD_PROFISSIONAL: "hub.equipe:add-profissional",
  /** Simular alocação. */
  EQUIPE_APPLY: "hub.equipe:apply",
  /** Aprovar alocação do coordenador. */
  EQUIPE_APPROVE_ALOCACAO: "hub.equipe:approve-alocacao",
  /** Cadastrar estaleiro e PPU anual. */
  ESTALEIRO_ADD_ESTALEIRO: "hub.estaleiro:add-estaleiro",
  /** Emitir pedidos de compra. */
  ESTALEIRO_ADD_PEDIDO: "hub.estaleiro:add-pedido",
  /** Cadastrar PPU da obra. */
  ESTALEIRO_ADD_PPU: "hub.estaleiro:add-ppu",
  /** Aprovar pedidos de compra. */
  ESTALEIRO_APPROVE_PEDIDO: "hub.estaleiro:approve-pedido",
  /** Gerenciar saldos do estaleiro. */
  ESTALEIRO_MANAGE_SALDO: "hub.estaleiro:manage-saldo",
  /** Criar escopo macro. */
  FINANCEIRO_ADD_ESCOPO: "hub.financeiro:add-escopo",
  /** Criar nova obra financeira. */
  FINANCEIRO_ADD_OBRA: "hub.financeiro:add-obra",
  /** Criar orçamentos. */
  FINANCEIRO_ADD_ORCAMENTO: "hub.financeiro:add-orcamento",
  /** Criar outlooks. */
  FINANCEIRO_ADD_OUTLOOK: "hub.financeiro:add-outlook",
  /** Criar simulações financeiras. */
  FINANCEIRO_ADD_SIMULACAO: "hub.financeiro:add-simulacao",
  /** Criar template. */
  FINANCEIRO_ADD_TEMPLATE: "hub.financeiro:add-template",
  /** Criar tipo de obra. */
  FINANCEIRO_ADD_TIPO: "hub.financeiro:add-tipo",
  /** Aplicar template. */
  FINANCEIRO_APPLY_TEMPLATE: "hub.financeiro:apply-template",
  /** Aprovar empresa. */
  FINANCEIRO_APPROVE_EMPRESA: "hub.financeiro:approve-empresa",
  /** Aprovar escopo macro. */
  FINANCEIRO_APPROVE_ESCOPO: "hub.financeiro:approve-escopo",
  /** Aprovar fichas financeira e FMM. */
  FINANCEIRO_APPROVE_FICHA: "hub.financeiro:approve-ficha",
  /** Aprovar nova obra. */
  FINANCEIRO_APPROVE_OBRA: "hub.financeiro:approve-obra",
  /** Aprovar orçamentos. */
  FINANCEIRO_APPROVE_ORCAMENTO: "hub.financeiro:approve-orcamento",
  /** Aprovar outlooks. */
  FINANCEIRO_APPROVE_OUTLOOK: "hub.financeiro:approve-outlook",
  /** Aprovar parâmetros financeiros. */
  FINANCEIRO_APPROVE_PARAMETRO_FINANCEIRO: "hub.financeiro:approve-parametro-financeiro",
  /** Aprovar parâmetros técnicos. */
  FINANCEIRO_APPROVE_PARAMETRO_TECNICO: "hub.financeiro:approve-parametro-tecnico",
  /** Aprovar projeção e contingência. */
  FINANCEIRO_APPROVE_PROJECAO_CONTINGENCIA: "hub.financeiro:approve-projecao-contingencia",
  /** Aprovar status financeiro. */
  FINANCEIRO_APPROVE_STATUS: "hub.financeiro:approve-status",
  /** Aprovar template. */
  FINANCEIRO_APPROVE_TEMPLATE: "hub.financeiro:approve-template",
  /** Aprovar tipo de obra. */
  FINANCEIRO_APPROVE_TIPO: "hub.financeiro:approve-tipo",
  /** Confirmar configuração de custos. */
  FINANCEIRO_CONFIRM_CUSTOS: "hub.financeiro:confirm-custos",
  /** Editar cenários. */
  FINANCEIRO_EDIT_CENARIO: "hub.financeiro:edit-cenario",
  /** Editar configurações financeiras (criar, editar, ativar e inativar). */
  FINANCEIRO_EDIT_CONFIGURACAO: "hub.financeiro:edit-configuracao",
  /** Editar detalhamento financeiro. */
  FINANCEIRO_EDIT_DETALHE: "hub.financeiro:edit-detalhe",
  /** Incluir ou editar empresa. */
  FINANCEIRO_EDIT_EMPRESA: "hub.financeiro:edit-empresa",
  /** Editar parâmetros financeiros. */
  FINANCEIRO_EDIT_PARAMETRO_FINANCEIRO: "hub.financeiro:edit-parametro-financeiro",
  /** Editar parâmetros técnicos. */
  FINANCEIRO_EDIT_PARAMETRO_TECNICO: "hub.financeiro:edit-parametro-tecnico",
  /** Gerenciar saldos e contingências. */
  FINANCEIRO_MANAGE_SALDO: "hub.financeiro:manage-saldo",
  /** Projetar custos. */
  FINANCEIRO_PROJECT_CUSTOS: "hub.financeiro:project-custos",
  /** Salvar status financeiro. */
  FINANCEIRO_SAVE_STATUS: "hub.financeiro:save-status",
  /** Visualizar cenários. */
  FINANCEIRO_VIEW_CENARIO: "hub.financeiro:view-cenario",
  /** Visualizar configurações financeiras. */
  FINANCEIRO_VIEW_CONFIGURACAO: "hub.financeiro:view-configuracao",
  /** Visualizar detalhamento financeiro. */
  FINANCEIRO_VIEW_DETALHE: "hub.financeiro:view-detalhe",
  /** Visualizar empresas. */
  FINANCEIRO_VIEW_EMPRESA: "hub.financeiro:view-empresa",
  /** Visualizar indicadores financeiros. */
  FINANCEIRO_VIEW_INDICADOR: "hub.financeiro:view-indicador",
  /** Visualizar orçamentos. */
  FINANCEIRO_VIEW_ORCAMENTO: "hub.financeiro:view-orcamento",
  /** Visualizar outlooks. */
  FINANCEIRO_VIEW_OUTLOOK: "hub.financeiro:view-outlook",
  /** Visualizar parâmetros. */
  FINANCEIRO_VIEW_PARAMETRO: "hub.financeiro:view-parametro",
  /** Acessar projeções. */
  FINANCEIRO_VIEW_PROJECAO: "hub.financeiro:view-projecao",
  /** Visualizar saldos e contingências. */
  FINANCEIRO_VIEW_SALDO: "hub.financeiro:view-saldo",
  /** Visualizar simulações financeiras. */
  FINANCEIRO_VIEW_SIMULACAO: "hub.financeiro:view-simulacao",
  /** Visualizar templates. */
  FINANCEIRO_VIEW_TEMPLATE: "hub.financeiro:view-template",
  /** Criar GMUD. */
  GMUD_ADD: "hub.gmud:add",
  /** Aprovar GMUD. */
  GMUD_APPROVE: "hub.gmud:approve",
  /** Atualizar GMUD. */
  GMUD_EDIT: "hub.gmud:edit",
  /** Visualizar GMUD. */
  GMUD_VIEW: "hub.gmud:view",
  /** Editar indicadores e textos. */
  INICIO_EDIT: "hub.inicio:edit",
  /** Visualizar início financeiro. */
  INICIO_VIEW_FINANCEIRO: "hub.inicio:view-financeiro",
  /** Visualizar início técnico. */
  INICIO_VIEW_TECNICO: "hub.inicio:view-tecnico",
  /** Criar obra. */
  OBRA_ADD: "hub.obra:add",
  /** Cadastrar avanço físico. */
  OBRA_ADD_AVANCO: "hub.obra:add-avanco",
  /** Solicitar código M. */
  OBRA_ADD_CODIGO_M: "hub.obra:add-codigo-m",
  /** Cadastrar diário de obras. */
  OBRA_ADD_DIARIO: "hub.obra:add-diario",
  /** Cadastrar fato relevante. */
  OBRA_ADD_FATO: "hub.obra:add-fato",
  /** Criar GMUD a partir da obra. */
  OBRA_ADD_GMUD: "hub.obra:add-gmud",
  /** Incluir lista de materiais. */
  OBRA_ADD_LISTA_MATERIAL: "hub.obra:add-lista-material",
  /** Criar grupo de materiais. */
  OBRA_ADD_MATERIAL: "hub.obra:add-material",
  /** Incluir medição do estaleiro. */
  OBRA_ADD_MEDICAO: "hub.obra:add-medicao",
  /** Aprovar avanço físico. */
  OBRA_APPROVE_AVANCO: "hub.obra:approve-avanco",
  /** Aprovar diário de obras. */
  OBRA_APPROVE_DIARIO: "hub.obra:approve-diario",
  /** Aprovar equipe técnica. */
  OBRA_APPROVE_EQUIPE: "hub.obra:approve-equipe",
  /** Aprovar escopo macro. */
  OBRA_APPROVE_ESCOPO: "hub.obra:approve-escopo",
  /** Aprovar GMUD da obra. */
  OBRA_APPROVE_GMUD: "hub.obra:approve-gmud",
  /** Aprovar medição do estaleiro. */
  OBRA_APPROVE_MEDICAO: "hub.obra:approve-medicao",
  /** Editar equipe técnica da obra. */
  OBRA_EDIT_EQUIPE: "hub.obra:edit-equipe",
  /** Editar datas e condição da obra. */
  OBRA_EDIT_SOBRE: "hub.obra:edit-sobre",
  /** Exportar serviços da obra. */
  OBRA_EXPORT: "hub.obra:export",
  /** Preencher shitlist. */
  OBRA_FILL_SHITLIST: "hub.obra:fill-shitlist",
  /** Importar lista do TM Master. */
  OBRA_IMPORT: "hub.obra:import",
  /** Solicitar escopo macro. */
  OBRA_REQUEST_ESCOPO: "hub.obra:request-escopo",
  /** Visualizar detalhamento da obra. */
  OBRA_VIEW: "hub.obra:view",
  /** Visualizar materiais. */
  OBRA_VIEW_MATERIAL: "hub.obra:view-material",
  /** Visualizar painel de obras. */
  OBRA_VIEW_PAINEL: "hub.obra:view-painel",
  /** Visualizar serviços. */
  OBRA_VIEW_SERVICO: "hub.obra:view-servico",
  /** Aprovar painel de controle. */
  PERFIL_APPROVE_PAINEL: "hub.perfil:approve-painel",
  /** Editar perfil (criar, alterar e excluir). */
  PERFIL_EDIT: "hub.perfil:edit",
  /** Visualizar perfis. */
  PERFIL_VIEW: "hub.perfil:view",
  /** Visualizar permissões. */
  PERMISSAO_VIEW: "hub.permissao:view",
  /** Criar relatórios padrão. */
  RELATORIO_ADD_PADRAO: "hub.relatorio:add-padrao",
  /** Criar relatórios personalizados. */
  RELATORIO_ADD_PERSONALIZADO: "hub.relatorio:add-personalizado",
  /** Exportar relatórios. */
  RELATORIO_EXPORT: "hub.relatorio:export",
  /** Visualizar relatórios. */
  RELATORIO_VIEW: "hub.relatorio:view",
  /** Super administração. */
  SYSTEM_SUPER_ADMIN: "hub.system:super-admin",
  /** Editar usuário. */
  USUARIO_EDIT: "hub.usuario:edit",
  /** Visualizar usuários. */
  USUARIO_VIEW: "hub.usuario:view",
} as const;

export type HubClaim = (typeof HUB_PERMISSOES)[keyof typeof HUB_PERMISSOES];
